import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const formatCurrency = (val) =>
  Number(val || 0).toLocaleString(undefined, { minimumFractionDigits: 2 });

function MobileOrderCard({
  record,
  onViewDetails,
  footerExtra,
  headerExtra,
  totalClass = 'success',
}) {
  const displayId = record.order_id || record.payment_id;
  const displayTotal =
    record.shop_total !== undefined
      ? record.shop_total
      : record.summary_net !== undefined
        ? record.summary_net
        : record.summary_total;

  let labelText = 'ยอดรวมทั้งหมด';
  let finalTotal = displayTotal;

  if (totalClass === 'danger' && record.order_id) {
    labelText = 'ยอดที่ต้องคืนผู้ซื้อ';
    finalTotal =
      record.order_status === 'PC_RTN_RCV' && record.return_shop_total !== undefined
        ? record.return_shop_total
        : (record.shop_total ?? displayTotal);
  } else if (totalClass === 'success' && record.order_id && record.shop_income !== undefined) {
    labelText = 'ยอดที่ต้องจ่ายผู้ขาย';
    finalTotal =
      record.order_status === 'PC_RTN_RCV' && record.return_shop_income !== undefined
        ? record.return_shop_income
        : (record.shop_income ?? displayTotal);
  }

  return (
    <div className='order-card'>
      <div
        className='order-card-header'
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          borderBottom: '1px solid #f0f0f0',
          paddingBottom: '10px',
          marginBottom: '12px',
        }}
      >
        <span
          className='order-id'
          style={{
            whiteSpace: 'nowrap',
            fontWeight: 700,
            fontSize: '14px',
            color: '#262626',
            paddingTop: '2px',
          }}
        >
          รหัส {displayId}
        </span>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            gap: '6px',
            flexShrink: 0,
          }}
        >
          <Button
            type='link'
            size='small'
            icon={<EyeOutlined />}
            onClick={() => onViewDetails(record.order_id || record)}
            style={{
              padding: 0,
              height: 'auto',
              display: 'flex',
              alignItems: 'center',
              gap: '2px',
            }}
          >
            รายละเอียด
          </Button>
          {headerExtra && (
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>{headerExtra}</div>
          )}
        </div>
      </div>
      <div className='order-card-body'>
        <div className='order-info-row'>
          <span className='label-info'>ผู้ซื้อ: {record.buyer_shopname}</span>
          {record.seller_shopname && (
            <span className='label-info'>ผู้ขาย: {record.seller_shopname}</span>
          )}
        </div>
        <div className='order-time'>
          วันที่: {dayjs(record.createtime).format('DD/MM/YYYY HH:mm')}
        </div>
      </div>
      <div className='order-card-footer'>
        <div style={{ textAlign: 'right', width: '100%' }}>
          {footerExtra ? (
            footerExtra
          ) : (
            <>
              {Number(record.summary_discount || 0) > 0 && !record.order_id && (
                <div
                  style={{
                    fontSize: '11px',
                    color: '#ff4d4f',
                    marginBottom: '2px',
                    fontWeight: 600,
                  }}
                >
                  ส่วนลด -{formatCurrency(record.summary_discount)} ฿
                  {record.coupon_id ? ` (🏷️ ${record.coupon_id})` : ''}
                </div>
              )}
              <div className='total-label'>{labelText}</div>
              <div className={`total-value ${totalClass}`}>{formatCurrency(finalTotal)} ฿</div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

MobileOrderCard.propTypes = {
  record: PropTypes.object.isRequired,
  onViewDetails: PropTypes.func.isRequired,
  footerExtra: PropTypes.node,
  headerExtra: PropTypes.node,
  totalClass: PropTypes.string,
};

export default MobileOrderCard;
